import { createSelector } from "reselect";

import { getCart } from "./state-accessors";

export const getCartTotal = createSelector([getCart], cart => {
  return cart.charges.total;
});
